/* eslint react/no-array-index-key:0 */
import React from 'react';
import PropTypes from 'prop-types';
import { propIs } from 'ramda';

import { Container, ExternalLink, P } from './styles';

const AddressBlock = ({ items }) => (
  <Container>
    {items.map((item, index) => (item.url ? (
      <ExternalLink
        key={index}
        href={item.url}
        target={item.target}
        rel="noopener noreferrer"
      >
        {propIs(Array, 'name', item) ? item.name.map((str, i) => (
          <P key={i}>{str}</P>
        )) : item.name}
      </ExternalLink>
    ) : <P key={index}>{item.name}</P>))}
  </Container>
);

AddressBlock.propTypes = {
  items: PropTypes.instanceOf(Array).isRequired,
};

export default AddressBlock;
